import { render } from "./CommentArea.vue?vue&type=template&id=c6a0ba32&scoped=true"
import script from "./CommentArea.vue?vue&type=script&lang=js"
export * from "./CommentArea.vue?vue&type=script&lang=js"

import "./CommentArea.vue?vue&type=style&index=0&id=c6a0ba32&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6a0ba32"]])

export default __exports__